// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cb-user-details-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  border: 1px solid var(--cb-border-color);
  border-radius: var(--cb-border-radius-lg);
  padding: 1rem 1.25rem;
}

.cb-user-details-section-header {
  margin-bottom: 1rem;
}

.cb-user-details-section-indentifier {
  width: 85%;
  align-self: self-start;
}

.cb-user-details-section-indentifiers-list {
  margin-top: 1rem;
}

.cb-user-details-section-indentifiers-list-item {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
}

.cb-user-details-section-indentifiers-list-item-field {
  flex: 8;
}

.cb-user-details-section-indentifiers-list-item-field-input {
  width: var(--cb-container-full-width);
}

.cb-user-details-section-indentifiers-list-item-badge {
  padding: 0.5rem;
  flex: 1;
  margin-top: 0.75rem;
  border-radius: var(--cb-border-radius-sm);
}

.cb-user-details-section-indentifiers-list-item-badge-primary {
  background-color: var(--cb-primary-color);
  color: var(--cb-button-text-primary-color);
}

.cb-user-details-section-indentifiers-list-item-badge-secondary {
  background-color: var(--cb-text-secondary-color);
  color: var(--cb-text-primary-color);
}

.cb-user-details-section-indentifiers-list-item-badge-text {
  color: var(--cb-button-text-primary-color);
}

@media screen and (max-width: 481px) {
  .cb-user-details-section-indentifier {
    width: 75%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/user.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,wCAAwC;EACxC,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,OAAO;EACP,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".cb-user-details-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  border: 1px solid var(--cb-border-color);\n  border-radius: var(--cb-border-radius-lg);\n  padding: 1rem 1.25rem;\n}\n\n.cb-user-details-section-header {\n  margin-bottom: 1rem;\n}\n\n.cb-user-details-section-indentifier {\n  width: 85%;\n  align-self: self-start;\n}\n\n.cb-user-details-section-indentifiers-list {\n  margin-top: 1rem;\n}\n\n.cb-user-details-section-indentifiers-list-item {\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.cb-user-details-section-indentifiers-list-item-field {\n  flex: 8;\n}\n\n.cb-user-details-section-indentifiers-list-item-field-input {\n  width: var(--cb-container-full-width);\n}\n\n.cb-user-details-section-indentifiers-list-item-badge {\n  padding: 0.5rem;\n  flex: 1;\n  margin-top: 0.75rem;\n  border-radius: var(--cb-border-radius-sm);\n}\n\n.cb-user-details-section-indentifiers-list-item-badge-primary {\n  background-color: var(--cb-primary-color);\n  color: var(--cb-button-text-primary-color);\n}\n\n.cb-user-details-section-indentifiers-list-item-badge-secondary {\n  background-color: var(--cb-text-secondary-color);\n  color: var(--cb-text-primary-color);\n}\n\n.cb-user-details-section-indentifiers-list-item-badge-text {\n  color: var(--cb-button-text-primary-color);\n}\n\n@media screen and (max-width: 481px) {\n  .cb-user-details-section-indentifier {\n    width: 75%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
